<template>
    <div>
        <b-modal
            :id="modalId"
            @hidden="onModalHidden()"
            modal-class="modal-otp"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="modal-base">
                <!-- <div class="modal-base-header">
                    <div class="close-header" @click="cancelOtp()">
                        <img src="@/assets/icon/icon-close-black.png" />
                    </div>
                </div> -->
                <div class="modal-base-body">
                    <div class="otp-title">
                        กรุณากรอกรหัส OTP
                    </div>
                    <div class="msg-title">
                        รหัส OTP จะถูกส่ง SMS <br />
                        ไปที่เบอร์โทรศัพท์มือถือ {{ formatted(tel) }}
                    </div>
                    <div class="text-otp-msg mb-1">
                        รหัสอ้างอิง :
                        <span class="text-ref">{{ refcode }}</span>
                    </div>
                    <div>
                        <label for="input-otp" class="input-otp">
                            <div class="d-flex justify-content-center">
                                <div class="box-input-otp">{{ otp[0] }}</div>
                                <div class="box-input-otp">{{ otp[1] }}</div>
                                <div class="box-input-otp">{{ otp[2] }}</div>
                                <div class="box-input-otp">{{ otp[3] }}</div>
                                <div class="box-input-otp">{{ otp[4] }}</div>
                                <div class="box-input-otp">{{ otp[5] }}</div>
                            </div>
                        </label>
                    </div>
                    <input
                        type="tel"
                        id="input-otp"
                        class="input-otp-dummy"
                        maxlength="6"
                        v-model="otp"
                        @input="onOtpChange()"
                    />
                    <div
                        class="err-otp"
                        v-if="this.$store.state.dupphone.isdup"
                    >
                        <span
                            v-if="
                                this.$store.state.dupphone.message ==
                                    'รหัส OTP ไม่ถูกต้อง'
                            "
                        >
                            รหัส OTP ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง
                        </span>
                        <span v-else>
                            {{ this.$store.state.dupphone.message }}
                        </span>
                    </div>
                    <div
                        class="text-otp-time"
                        :class="{ expired: isExpireTime }"
                    >
                        รหัสจะหมดอายุภายใน
                        <span class="text-time"
                            >{{ timeHelper.displayTime }} วินาที</span
                        >
                    </div>
                    <div
                        class="text-otp-time"
                        v-if="isExpireTime"
                        :class="{ expired: isExpireTime }"
                        @click="resendOtp()"
                    >
                        <u class="resend">ส่ง OTP อีกครั้ง</u>
                    </div>
                    <div class="footer-modal-otp d-flex">
                        <div class="btn-cancel" @click="cancelOtp()">
                            ยกเลิก
                        </div>
                        <div
                            class="btn-red"
                            :class="{ disabled: this.otp.length != 6 }"
                            v-if="!isExpireTime"
                            @click="onSubmitOtp()"
                        >
                            {{ lbl.default.confirm }}
                        </div>
                        <div
                            class="btn-red"
                            :class="{ disabled: this.otp.length != 6 }"
                            v-else
                        >
                            {{ lbl.default.confirm }}
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Locale from "@/helper/locale/locale.js";
// import Util from "@/helper/Utility.js";
import TimerHelper from "@/helper/TimerHelper.js";
//service
import BzbsOtp from "@/core/Otp/service/BzbsOtp.js";
//mixin
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
//helper
import { TrackingService } from "@/helper/TrackingHelper.js";

/**
 * ! This file copy form Food Hunt
 * @property {AlertModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "OtpModal",
    props: {
        // busModal: Object,
        controller: Object,
        modalId: String
    },
    mixins: [ErrorApiMixin],
    data: function() {
        return {
            busModal: null,
            lbl: Locale.getLbl(),

            tel: "",
            otp: "123456",
            refcode: "123456",
            channel: "",

            timeHelper: new TimerHelper(),
            isExpireTime: false,

            tracking: new TrackingService(this),
            trackingClose: "click_close",
            trackingConfirm: "click_confirm",
            errorMessage: "",
            isErrorMessage: false
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
        this.timeHelper.initialTimer(60 * 3, null, false, false);
    },
    mounted: function() {
        this.busModal.$on("show", this.show);
        this.busModal.$on("hide", this.hide);
        this.busModal.$on("startOtp", this.startOtp);
        this.busModal.$on("cancelOtp", this.cancelOtp);
        this.busModal.$on("clearOtp", this.clearOtp);
        // this.busModal.$on("resendOtp", this.resendOtp);
    },
    methods: {
        formatted: function(input) {
            var n1, n2, n3;
            // var formatted = input;
            if (input) {
                n1 = input.substr(0, 3);
                n2 = input.substr(3, 3);
                n3 = input.substr(6);
                input = n1 + "-" + n2 + "-" + n3;
            }
            return input;
        },
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function() {
            this.hide();
            this.controller.sendCallbackOk({ tag: this.tag });
        },
        show: function() {
            this.showModal();
        },
        showModal: function() {
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
        clearOtp: function() {
            this.otp = "";
        },
        //#region otp
        startOtp: async function(config) {
            this.controller.loadingModal.show();
            this.isExpireTime = false;
            this.tel = config.tel;
            this.refcode = "";
            this.otp = "";
            this.channel = config.channel;
            this.isTracking = config.isTracking;
            this.trackingCat = config.trackingCat;
            this.trackingAction = config.trackingAction;
            this.isErrorMessage = false;

            var success = await this.apiRequestOtp();
            if (success) {
                this.controller.loadingModal.hide();
                this.timeHelper.runTimer(() => {
                    this.setTimeout();
                });

                this.showModal();
            }
        },
        apiRequestOtp: async function() {
            return new Promise((resolve, reject) => {
                BzbsOtp.requestOtp(this.tel, null, this.channel).subscribe(
                    data => {
                        console.log(data);
                        this.refcode = data.refcode;
                        resolve(true);
                    },
                    err => {
                        this.controller.loadingModal.hide();
                        if (err.id == 2078) {
                            this.controller.alertModal
                                .clearText()
                                .setMsg(err.message)
                                .show();
                            this.controller.alertModal.onClickOk(() => {
                                this.controller.sendCallbackError(err);
                            });
                        } else {
                            this.errorResponse(err);
                        }

                        reject(false);
                    }
                );
            });
        },

        cancelOtp: function() {
            this.timeHelper.stopTimer();
            this.timeHelper.resetTimer();

            if (this.isTracking != null) {
                this.tracking.event(this.trackingCat, this.trackingClose);
            }
            this.$store.commit("setDupphone", {
                isdup: false,
                message: ""
            });
            this.hide();
            this.controller.sendCallbackCancel();
        },
        onOtpChange: function() {
            this.otp = this.otp.replace(/\D/g, "");
        },

        setTimeout: function() {
            this.timeHelper.stopTimer();
            this.timeHelper.resetTimer();
            this.isExpireTime = true;
        },

        onSubmitOtp: function() {
            window._lt(
                "send",
                "cv",
                {
                    type: "ConfirmButton"
                },
                ["2360d21e-79ce-4697-9bc0-02f5f2555aef"]
            );

            window.fbq("trackCustom", "ConfirmButton");

            window.gtag_report_conversion(
                window.location.href,
                "AW-970877309/yEKBCKbfpqEDEP3S-c4D"
            );

            if (this.validateOtp()) {
                this.isErrorMessage = true;
                var otpConfig = {
                    tel: this.tel,
                    otp: this.otp,
                    refcode: this.refcode
                };
                // console.log(otpConfig.refcode, 'otpConfig')
                this.controller.sendCallbackSubmitOtp(otpConfig);
            }
            if (this.isTracking != null) {
                this.tracking.event(this.trackingCat, this.trackingConfirm);
            }
        },

        validateOtp: function() {
            if (this.otp.length != 6) {
                var errorMsg = this.lbl.otp.otpLength;
                if (this.otp == "") {
                    errorMsg = this.lbl.otp.requireInput;
                }

                this.hide();
                this.controller.alertModal
                    .clearText()
                    .setMsg(errorMsg)
                    .show();
                this.controller.alertModal.onHidden(() => {
                    this.showModal();
                });
                return false;
            }

            return true;
        },
        resendOtp: async function() {
            this.controller.loadingModal.show();
            this.isExpireTime = false;
            // this.tel = config.tel;
            this.refcode = "";
            this.otp = "";
            this.isErrorMessage = false;

            this.clickResend();
            await this.apiRequestOtp();
            this.controller.loadingModal.hide();
            this.timeHelper.runTimer(() => {
                this.setTimeout();
            });

            // this.showModal();
        },

        clickResend: function() {
            if (this.isTracking != null) {
                this.tracking.event(this.trackingCat, this.trackingAction);
            }
        }
        //#endregion otp
    }
};
</script>
<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/modal.scss";
@import "./OtpModal.scss";
</style>
